/**
 * A KIZÁRÁS VISSZAVONÁSI ABLAKA — tiszta függvények, React nélkül.
 *
 * A D9 `X`-e („kizárás a normál menetből, naplózva") egyetlen leütés, és a
 * `NOT_DEDUCTIBLE` a `FILED`-del egyenrangú KILÉPÉS: nincs visszaút belőle.
 * Egy elgépelt `X` tehát véglegesen kivenne egy papírt a munkalistáról.
 *
 * A VÁLASZTÁS: rövid visszavonási ablak, és a kérés CSAK ANNAK LETELTÉVEL
 * indul el *(Viktor, 09-03)*. A másik két út elvetve:
 *
 *   • **azonnali kérés, szerveroldali visszavonással** — minden meggondolt
 *     leütés KÉT naplósort írna, és pont azt a naplót hígítaná fel, amiért a
 *     művelet naplózott;
 *   • **kötelező indok** — a hiánylista `X`-énél jogos (ott egy VALÓDI hiányt
 *     lehet elrejteni), a munkalistán viszont naponta sokszor futna, és egy
 *     kötelező mező minden parkolójegynél megállítaná a kezet.
 *
 * ⚠️ AMIT EZ VÁLLAL: ha a könyvelő az ablakon belül bezárja a lapot, a
 * kizárás NEM történik meg. Ez a biztonságos alapértelmezés — a papír a
 * munkalistán marad, és holnap újra eldöntheti. A fordítottja (elküldött,
 * de meg nem történtnek hitt kizárás) csendben tüntetne el munkát.
 */

import type { WorklistItem } from './types';

/**
 * MENNYI IDŐ A MEGGONDOLÁSRA.
 *
 * Hat másodperc: elég ahhoz, hogy a sáv megjelenését észrevegye és a
 * „Visszavonom"-ig érjen a keze, de rövid ahhoz, hogy sorozatban `X`-elve ne
 * gyűljön fel egy hosszú, átláthatatlan lista. Az érték itt áll, egy helyen —
 * a tesztek is innen olvassák.
 */
export const UNDO_WINDOW_MS = 6000;

/** Egy kizárás, ami még visszavonható. */
export interface PendingExclusion {
  documentId: string;
  /** A sor, ahogy eltűnt — ebből áll vissza a kupacban. */
  item: WorklistItem;
  /** Mikor jár le az ablak — `Date.now()` alapú. */
  dueAt: number;
}

/**
 * MELYIK KIZÁRÁS ESEDÉKES MOST.
 *
 * Külön függvény, mert az időzítés az egyetlen dolog, amit a horogban nem
 * lehet tisztán tesztelni — itt viszont az idő PARAMÉTER, nem globális
 * állapot.
 */
export function dueNow(pending: PendingExclusion[], now: number): PendingExclusion[] {
  return pending.filter((one) => one.dueAt <= now);
}

/** Ami még vár. A kettő együtt adja ki a teljes listát, átfedés nélkül. */
export function stillWaiting(pending: PendingExclusion[], now: number): PendingExclusion[] {
  return pending.filter((one) => one.dueAt > now);
}

/**
 * MENNYI IDŐ VAN MÉG — másodpercben, FÖLFELÉ kerekítve.
 *
 * Lefelé kerekítve az utolsó másodpercben „0"-t mutatna, miközben a
 * visszavonás még él — a könyvelő azt hinné, lekéste. Nullánál kisebbet nem
 * adunk vissza: a lejárt ablak nem „−1 másodperc".
 */
export function secondsLeft(entry: PendingExclusion, now: number): number {
  return Math.max(Math.ceil((entry.dueAt - now) / 1000), 0);
}
